import { DocsCallout, DocsCodeBlock, DocsSteps } from "../components"

<DocsSteps>
  <li>Open a site workspace and go to the Tracking tab.</li>
  <li>Copy the install snippet after measurement is configured.</li>
  <li>Install it once on every public page, preferably in the document head or tag manager.</li>
  <li>Use the realtime check to confirm page views and form activity are arriving.</li>
</DocsSteps>

<DocsCallout title="What the tag captures">
  The tag captures page views, CTA clicks, form starts, form submissions, signup journeys, and
  strong identity hashes when forms provide email or phone fields.
</DocsCallout>

<DocsCodeBlock language="html">
{`<script async src="https://adgiro.com/t/YOUR_PUBLIC_KEY.js"></script>`}
</DocsCodeBlock>

The raw event stream belongs in GA4. Adgiro uses D1 for mappings, summaries, retryable jobs, and
operational state.
